import React, { useMemo, useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiTextColor} from '@elastic/eui';
import { ComboSubFuncionesContainer as ComboSubFunciones} from '../../../components/Combos/SubFunciones/container';
import { createOptions } from '../../../components/Combos/SubFunciones/functions';

export const Formulario = (props)=>{

  let {onSave, selected, onClose} = props
  let [funcion,setFuncion] = useState(selected ? selected.funcion : undefined)
  let [subFunciones, setSubFunciones] = useState(selected ? createOptions(selected.subFunciones) : []);

  const getData = () =>{
    let data = { funcion: funcion, subFunciones: subFunciones.map((x) => {return {idSubFuncion : x.value}})}
    if(selected){
      return {...selected,...data}
    }else{
      return data
    }
  }

  const onSaveData = () =>{
    if(!comprobarErrores()){
      let newData = getData();
      onSave && onSave(newData)
    }
  }

  const comprobarErrores = () => {
    return (isInvalidFuncion || isInvalidSubFuncion)
  }

  const isInvalidFuncion = useMemo(() => {return funcion===undefined || funcion.trim()===""},[funcion])
  const isInvalidSubFuncion = useMemo(() => {return subFunciones===undefined || subFunciones.length === 0},[subFunciones])


  return (
    <>
    <EuiFlexGroup>
      <EuiFlexItem>
          <EuiFormRow fullWidth label="Función" isInvalid={isInvalidFuncion}>
            <EuiFieldText fullWidth value={funcion} name="txtFuncion" onChange={e => setFuncion(e.target.value)} isInvalid={isInvalidFuncion}/>
          </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Sub Funciones" isInvalid={isInvalidSubFuncion}>
          <ComboSubFunciones fullWidth singleSelection={false} selectedOptions={subFunciones} onChange={selectedOptions => setSubFunciones(selectedOptions)} isInvalid={isInvalidSubFuncion} />
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>

    {comprobarErrores() ? 
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="">
          <EuiTextColor color="danger"><br/>{"Faltan campos por rellenar"}</EuiTextColor>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    :null}
    <EuiSpacer size="m" />

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiButton onClick={onSaveData} disabled={comprobarErrores()}>
          Guardar
        </EuiButton>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiButton color="danger" onClick={()=>onClose()}>Cancelar</EuiButton>
      </EuiFlexItem>
    </EuiFlexGroup>
    </>
      
  )
}
export default Formulario;